import { createSelector } from 'reselect';
import { IStore } from 'store/interface';

export const getToolBarStatus = createSelector(
  ({ toolBarReducer }: IStore) => toolBarReducer,
  toolBarReducer => toolBarReducer
);
